import Enquire from 'enquire.js';
import Pubsub from 'pubsub-js';
import Events from './Events';

const medias = { DESKTOP: 'desktop', TABLET: 'tablet', MOBILE: 'mobile' };
let media = medias.DESKTOP;

Enquire.register('screen and (min-width:992px)', {
  match: function matchDesktop() {
    media = medias.DESKTOP;
    Pubsub.publish(Events.CHANGE_MEDIA);
  },
});

Enquire.register('screen and (max-width:767px)', {
  match: function matchMobile() {
    media = medias.MOBILE;
    Pubsub.publish(Events.CHANGE_MEDIA);
  },
  unmatch: function matchDesktop() {
    media = medias.TABLET;
    Pubsub.publish(Events.CHANGE_MEDIA);
  },
});

export default {
  events: Events,
  medias,
  getMedia() {
    return media;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/MediaManager.js